import React from 'react';
import variables from '../../../../../_metronic/variables.scss';

const Footer = () => (
  <div style={{height: 8, marginRight: -20, marginLeft: -20}} className="row">
      <div style={{background: variables.footerColorPrimary }} className="col"/>
      <div style={{background: variables.footerColorSecondary }} className="col"/>
      <div style={{background: variables.footerColorTertiary }} className="col"/>
      <div style={{background: variables.footerColorQuartiary }} className="col"/>
      <div style={{background: variables.footerColorQuintiary }} className="col"/>
    </div>
);

export default Footer;
